<template>
  <q-layout view="lHh Lpr lFf" class="public-layout">
    <q-page-container>
      <router-view v-slot="{ Component }">
        <Transition name="page-fade" mode="out-in">
          <component :is="Component" />
        </Transition>
      </router-view>
    </q-page-container>
    <!-- KdsConsentBanner uses localStorage — client-only rendering to avoid SSR mismatch -->
    <KdsClientOnly>
      <KdsConsentBanner />
    </KdsClientOnly>
  </q-layout>
</template>

<script setup lang="ts">
import { useLocale } from '@/composables/useLocale';
import KdsClientOnly from '@/kds/primitives/KdsClientOnly.vue';
import KdsConsentBanner from '@/kds/components/KdsConsentBanner.vue';

useLocale();
</script>

<style scoped lang="scss">
.public-layout {
  background: var(--paper);
  color: var(--ink);
}

// Route transition
.page-fade-enter-active,
.page-fade-leave-active {
  transition: opacity var(--d-base) var(--ease-out);
}

.page-fade-enter-from,
.page-fade-leave-to {
  opacity: 0;
}

@media (prefers-reduced-motion: reduce) {
  .page-fade-enter-active,
  .page-fade-leave-active {
    transition: none !important;
  }
}
</style>
